import { useContext, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "context/UserContext";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import Sidebar from "shared/template/sideBar/SideBar";
import Header from "shared/template/header/Header";
import { usePermissoesContext } from "context/permissoes/PermissoesContext";

export const PrivateLayout = () => {
  const { usuarioLogado } = useContext(UserContext);
  const [isSideBarAberto, setIsSideBarAberto] = useState<boolean>(true);
  const { isPermissoesCarregadas } = usePermissoesContext();

  if (!usuarioLogado || !usuarioLogado.id) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {isPermissoesCarregadas && (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <Sidebar isSideBarAberto={isSideBarAberto} />
          <div style={{ width: "100%", padding: "0px 15px" }}>
            <Header isSideBarAberto={isSideBarAberto} setIsSideBarAberto={setIsSideBarAberto} />
            <div style={{ minHeight: "740.875px" }}>
              <Outlet />
            </div>
          </div>
        </Box>
      )}
    </>
  );
};
